import { colors, typography } from "../../../design/tokens";
import { CollectionType, RankingsAllResponse, StoreType } from "../../../model/rankings";
import { AppStoreRankingColumn } from "./AppStoreRankingColumn";

interface AppStoreRankingsGridProps {
  rankings: RankingsAllResponse;
  store: StoreType;
  country: string;
}

const COLUMNS: { key: CollectionType; label: string }[] = [
  { key: "free", label: "Free" },
  { key: "paid", label: "Paid" },
  { key: "grossing", label: "Grossing" },
];

export function AppStoreRankingsGrid({
  rankings,
  store,
  country,
}: AppStoreRankingsGridProps) {
  return (
    <div className="grid grid-cols-3 gap-8">
      {COLUMNS.map(({ key, label }) => (
        <div key={key}>
          <h2 className={`${typography.size.lg} ${typography.weight.semibold} ${colors.text.primary} mb-4 px-3`}>{label}</h2>
          <AppStoreRankingColumn
            apps={rankings[key]}
            store={store}
            country={country}
          />
        </div>
      ))}
    </div>
  );
}
